import React from "react";
import ReactECharts from "echarts-for-react";
import { useSelector } from "react-redux";

function Echarts() {
  const reportingHistory = useSelector(
    (state) => state.insight.tab1.data?.reportingHistory
  );

  const option = {
    title: {
      text: "6 Month History",
      left: "left",
      top: "top",
      textStyle: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#000000",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    toolbox: {
      show: true,
      feature: {
        dataZoom: { yAxisIndex: "none" },
        restore: {},
        mark: { show: true },
        dataView: { show: true, readOnly: true },
        saveAsImage: { show: true, name: "gateway_insights" },
      },
    },
    grid: {
      left: 60,
      top: 80,
      right: 60,
      bottom: 80,
    },
    legend: {
      data: ["Gateway Count", "Avg Battery"],
      left: "center",
      icon: "roundRect",
    },
    xAxis: [
      {
        type: "category",
        data: reportingHistory.date,
        boundaryGap: false,
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "Gateway Count",
        nameGap: 40,
        nameRotate: 90,
        nameLocation: "middle",
      },
      {
        type: "value",
        name: "Avg Battery",
        min: 0,
        max: 100,
        nameGap: 40,
        nameRotate: -90,
        nameLocation: "middle",
      },
    ],
    series: [
      {
        name: "Gateway Count",
        type: "line",
        data: reportingHistory.gatewayCount,
        symbol: "none",
        itemStyle: {
          color: "#FF8027",
        },
        markLine: {
          data: [{ name: "Target", yAxis: 450 }],
          label: { position: "start" },
          symbol: "none",
          lineStyle: {
            color: "#D52B1E",
          },
        },
      },
      {
        name: "Avg Battery",
        type: "line",
        yAxisIndex: 1,
        data: reportingHistory.avgBattery,
        symbol: "none",
        itemStyle: {
          color: "#0089EC",
        },
      },
    ],
    dataZoom: [
      { type: "inside", start: 0, end: 100 },
      { start: 0, end: 100 },
    ],
  };

  return <ReactECharts style={{ height: "500px", width: "100%" }}   option={option} />;
}

export default Echarts;
